quoteModule.controller('proposalCloneDialogController',
    ['$scope', '$mdDialog',  function ($scope, $mdDialog) {

        var ctrl = this;
        $scope.loading = false;

        ctrl.hide = function() {
            ///$scope.$broadcast('productSettingsSave');
            $mdDialog.hide();
        };

        ctrl.cancel = function() {
            $mdDialog.cancel();
        };

        //ctrl.views = {
        //    view: "View",
        //    profitType: "ProfitType",
        //    additionalMarkup: "AdditionalMarkup",
        //    overRemit: "OverRemit",
        //    defaults: "Defaults"
        //};
        //
        //var activeView = ctrl.views.profitType;

        //ctrl.setActiveView  = function (viewName) {
        //    activeView = viewName;
        //    console.log("activeView", activeView);
        //};
        //
        //ctrl.isViewActive = function(viewName) {
        //    return (activeView === viewName) ? true : false;
        //};
    }]);